const showToast = (text, options = {}) => {
    Toastify({
        text: text,
        avatar: '/static/i/icon-warning.svg',
        position: "right",
        ...options
    }).showToast()
}
